<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  variant: {
    type: String,
    default: 'lg',
    validator: value => ['lg', 'md'].includes(value),
  },
});

const store = useStore();
const globalConfig = computed(() => store.getters['globalConfig/get']);

const brandName = computed(
  () => globalConfig.value.brandName || globalConfig.value.installationName || 'Fluxat'
);

const logoLight = '/brand-assets/logo-1024-light.png';
const logoDark = '/brand-assets/logo-1024-dark.png';

const lockupClass = computed(() =>
  props.variant === 'lg' ? 'auth-brand-lockup--lg' : 'auth-brand-lockup--md'
);
</script>

<template>
  <div
    class="flex w-full justify-center"
    role="img"
    :aria-label="`${brandName}.ai`"
  >
    <span
      class="auth-brand-lockup inline-flex items-center min-w-0"
      :class="lockupClass"
    >
      <span class="inline-flex shrink-0 items-center leading-none">
        <img
          :src="logoLight"
          alt=""
          aria-hidden="true"
          class="auth-brand-logo-img block dark:hidden"
        />
        <img
          :src="logoDark"
          alt=""
          aria-hidden="true"
          class="auth-brand-logo-img hidden dark:block"
        />
      </span>
      <span
        class="auth-brand-name font-extrabold tracking-tight text-n-slate-12 whitespace-nowrap leading-none"
      >
        {{ brandName }}<span class="text-n-brand">.ai</span>
      </span>
    </span>
  </div>
</template>

<style scoped>
.auth-brand-lockup {
  gap: 0.6rem;
}

.auth-brand-lockup--lg .auth-brand-logo-img {
  height: 2.25rem;
  width: auto;
  max-width: min(9rem, 42vw);
  object-fit: contain;
  object-position: left center;
}

.auth-brand-lockup--lg .auth-brand-name {
  font-size: 1.35rem;
  letter-spacing: -0.03em;
}

.auth-brand-lockup--md .auth-brand-logo-img {
  height: 1.75rem;
  width: auto;
  max-width: min(8rem, 40vw);
  object-fit: contain;
  object-position: left center;
}

.auth-brand-lockup--md .auth-brand-name {
  font-size: 1.12rem;
  letter-spacing: -0.03em;
}
</style>
